/**
 * TeamChatRoot
 *
 * Thin wrapper that reads the current user from AuthContext
 * and provides the TeamChatManagerProvider with the correct user data.
 * Mount this once inside AuthProvider + SocketProvider.
 */

import React, { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { TeamChatManagerProvider } from './TeamChatManager';

interface Props {
  children: ReactNode;
}

export const TeamChatRoot: React.FC<Props> = ({ children }) => {
  const { state } = useAuth();
  const user = state.user;

  if (!user) {
    // Not authenticated — render children without team chat context
    return <>{children}</>;
  }

  return (
    <TeamChatManagerProvider
      currentUserId={user.id}
      appId={user.appId}
      companyId={user.companyId}
    >
      {children}
    </TeamChatManagerProvider>
  );
};
